/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListScopesSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListScopesRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListScopesSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListScopesSecurity$outboundSchema: z.ZodMiniType<
  ListScopesSecurity$Outbound,
  ListScopesSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listScopesSecurityToJSON(
  listScopesSecurity: ListScopesSecurity,
): string {
  return JSON.stringify(
    ListScopesSecurity$outboundSchema.parse(listScopesSecurity),
  );
}

/** @internal */
export type ListScopesRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListScopesRequest$outboundSchema: z.ZodMiniType<
  ListScopesRequest$Outbound,
  ListScopesRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function listScopesRequestToJSON(
  listScopesRequest: ListScopesRequest,
): string {
  return JSON.stringify(
    ListScopesRequest$outboundSchema.parse(listScopesRequest),
  );
}
